<template lang="html">
  <Row>
    <Col :span="24">
      <Card class="card-box">
        <div class="text-center" v-if="isEtaComplianceLoading">
          <Spinner/>
        </div>
        <div class="status-msg" v-else-if="!deliveryEtaDetails">
          <span>
            <svgicon :name="emptyDashboardIcon" width="150" height="115" :original="true" />
            <p class="mt-0 ml-30">No data available</p>
          </span>
        </div>
        <Row :gutter="40" v-else>
          <Col :span="12">
            <div class="header-text">
              Delivery vs ETA
            </div>
            <Graph
              :graphDetail="deliveryEtaDetails"
              :headerConstant="etaBarChartConstants">
            </Graph>
          </Col>

          <Col :span="12">
            <Row :gutter="40" class="list-bordered divider col-pt-15">
              <Col :span="12"  v-for="header in etaDetailsHeaders" :key="header.id" :class="header.class">
               <Tooltip :open-delay="100" popper-class="max-width"  effect="dark" placement="top">
                      <div slot="content">
                          <span v-html="trackingDashboard[header.column]"></span>
                      </div>
                <ColCell
                  :header="header"
                  :value="deliveryEtaDetails[header.column]">
                </ColCell>
              </Tooltip>
              </Col>
            </Row>

          </Col>
        </Row>
      </Card>
    </Col>
  </Row>
</template>

<script>
import ColCell from '@/components/track/ColCell';
import Graph from '@/components/track/Graph';
import {
  etaDetailsHeaders,
  etaBarChartConstants,
} from '@/constants/trackConstants';
import SecFilterMixin from '@common/mixins/SecFilterMixin';

export default {
  components: {
    ColCell,
    Graph,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      etaDetailsHeaders,
      etaBarChartConstants,
    };
  },
  props: ['etaCompliance', 'isEtaComplianceLoading', 'trackingDashboard'],
  computed: {
    deliveryEtaDetails() {
      return this.etaCompliance && this.etaCompliance.deliveryEta;
    },
  },
};
</script>
